import { render, staticRenderFns } from "./CommissionPlanAddNew.vue?vue&type=template&id=2499048a&"
import script from "./CommissionPlanAddNew.vue?vue&type=script&lang=js&"
export * from "./CommissionPlanAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CommissionPlanAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports